/* eslint-disable jira/filename-case */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { asyncValues } from '@jira/polaris__lib-ts-utils/src/async-value.tsx';
import { createErrorAnalytics } from '@jira/polaris__lib-errors/src/createErrorAnalytics.tsx';
import { updateProductSettingsViewBlueprints } from './updateProductSettingsViewBlueprints.tsx';
import type { Props, State } from './ProductSettingsResponse.types.tsx';

export const updateViewBlueprintsEnabled =
	(enabled: boolean): Action<State, Props, Promise<void>> =>
	async ({ setState, getState }) => {
		const previousState = getState();

		if (previousState.productSettings.status !== 'loaded') {
			return;
		}

		const previousViewBlueprintsEnabledValue =
			previousState.productSettings.value.viewBlueprints.enabled;

		try {
			await updateProductSettingsViewBlueprints(enabled);
			const latestState = getState();
			const latestLoadedSettings =
				latestState.productSettings.status === 'loaded'
					? latestState.productSettings.value
					: previousState.productSettings.value;

			setState({
				productSettings: asyncValues.loaded({
					...latestLoadedSettings,
					viewBlueprints: {
						enabled,
					},
				}),
			});
		} catch (error) {
			if (error instanceof Error) {
				fireErrorAnalytics(
					createErrorAnalytics('polaris.error.updateViewBlueprintsSwitchFailed', error),
				);
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.error.controllers.product-settings.update-view-blueprints-switch',
				'Failed to update view blueprints switch',
				error instanceof Error ? error : new Error(String(error)),
			);

			setState({
				productSettings: asyncValues.loaded({
					...previousState.productSettings.value,
					viewBlueprints: {
						enabled: previousViewBlueprintsEnabledValue,
					},
				}),
			});

			throw error;
		}
	};
